import Vue from 'vue';
import  EventEmitter from 'events';
import Modal from '@/components/modal';

//控制遮罩层唯一
let dirty = true;
function createComponent(modal, component, modalProps, props) {
    const event = new EventEmitter();
    if(!dirty) return;
    const vm = new Vue({
        el: document.createElement('div'),
        functional: true,
        destroyed() {
            const parent = this.$el.parentNode;
            if (parent) {
              parent.removeChild(this.$el);
              dirty = true;
            }
        },
        created() {
            dirty = false;
        },
        render(h, context) {
            return h(modal, {
                    props: modalProps,
                    on: {
                        close: function() {
                          event.emit('close');
                        },
                      },
                },
                [
                    h(component, {
                        props,
                        on: {
                            close: function() {
                              event.emit('close');
                            },
                          },
                    })
                ]
            );
        },
    });
    document.body.appendChild(vm.$el);
    return new Promise((resolve, reject) => {
        event.once('close', () => {
            vm.$destroy();
            resolve();
        });
    });
}

function open(component, options = {}) {
    const {props = {}} = options;
    return createComponent(Modal, component, options, props);
} 

export default open;